export var EDocumentPackageSignerRole;
(function (EDocumentPackageSignerRole) {
    EDocumentPackageSignerRole["Signer"] = "SIGNER";
    EDocumentPackageSignerRole["Tenant"] = "TENANT";
    EDocumentPackageSignerRole["Parent"] = "PARENT";
    EDocumentPackageSignerRole["Owner"] = "OWNER";
    EDocumentPackageSignerRole["Broker"] = "BROKER";
    EDocumentPackageSignerRole["Payer"] = "PAYER";
    EDocumentPackageSignerRole["MandatedOwner"] = "MANDATED_OWNER";
})(EDocumentPackageSignerRole || (EDocumentPackageSignerRole = {}));
